// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-wrapper[data-v-6005f660]{width:100%}@media(min-width: 1600px){.preview-wrapper[data-v-6005f660]{width:60rem}}@media(min-width: 992px)and (max-width: 1599.98px){.preview-wrapper[data-v-6005f660]{width:45rem}}.preview-wrapper.preview-animation[data-v-6005f660],.preview-wrapper.preview-video_live[data-v-6005f660]{background-color:#000;border-radius:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
